var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_7017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0748 9.12255C12.0748 9.19441 11.967 11.3155 14.3038 12.43C13.8724 13.7603 12.3625 16.7083 10.6008 16.7083C9.5942 16.7083 9.01899 16.0611 7.86855 16.0611C6.68215 16.0611 6.03503 16.7083 5.13625 16.7083C3.41058 16.7802 1.75682 13.5445 1.28945 12.2143C0.929938 11.2077 0.786133 10.237 0.786133 9.30226C0.786133 6.10261 2.90726 4.5567 4.92054 4.52075C5.89122 4.52075 7.11357 5.20382 7.65284 5.20382C8.15613 5.20382 9.55827 4.37694 10.8525 4.48479C12.1827 4.59265 13.1893 5.09597 13.8724 6.06666C12.6861 6.82163 12.0748 7.79233 12.0748 9.12255ZM10.0616 3.2265C9.34256 4.05338 8.4797 4.52075 7.54499 4.44884C7.47309 3.47816 7.8326 2.57937 8.4797 1.86034C9.05492 1.21322 10.0616 0.673953 10.9244 0.602051C10.9244 0.997516 11.0323 2.07606 10.0616 3.2265Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_7017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5177,
    height: 17.075,
    fill: "white",
    transform: "translate(0.786133 0.219482)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple-store.e08904683dd79d66579b1b00000f7a94.svg";
export { ForwardRef as ReactComponent };